import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import classNames from 'classnames';
import moment from 'moment';
import { FC } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { auctionApi, AuctionBidDetails } from 'src/api/auctionApi';
import userInfoStyles from '../UserInfo.module.scss';
import styles from './AuctionSection.module.scss';
import { getTimeLeft } from './utils';

interface AuctionSectionProps {
  auctionId: string;
  tribeId: string;
  tribeName: string;
  leaderName: string;
  tribeAvatar: string;
  auctionData: any;
  isMobile?: boolean;
  auctionBidsInfo: AuctionBidDetails | null;
}

export const AuctionSection: FC<AuctionSectionProps> = ({
  auctionId,
  auctionData,
  isMobile,
  auctionBidsInfo,
}) => {
  const navigate = useNavigate();
  const auctionLink = `${window.location.origin}/auction/${auctionId}`;
  const { closeDate, open_seat_count, createdAt } = auctionData;

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(auctionLink)
      .then(() => {
        toast.success('Link copied to clipboard!');
      })
      .catch(() => {
        toast.error('Failed to copy link.');
      });
  };

  const handleGoToAuction = () => {
    if (auctionId) {
      navigate(`/auction/${auctionId}`);
    } else {
      alert('Auction ID not available');
    }
  };
  const handleCancelAuction = async () => {
    if (auctionId) {
      await auctionApi.cancelAuction(auctionId);
      window.location.reload();
    }
  };

  if (!auctionId) {
    return null;
  }

  const formattedCreatedAt = createdAt
    ? moment(createdAt).format('MMM DD, YYYY')
    : 'N/A';
  const formattedCloseDate = closeDate
    ? moment(closeDate).format('MMM DD, YYYY')
    : 'N/A';

  return (
    <div
      className={classNames(userInfoStyles.auction, {
        [userInfoStyles.mobileAuction]: isMobile,
      })}
    >
      <div className={userInfoStyles.auctionInfoWrapper}>
        <div>
          Auction:{' '}
          <span className={userInfoStyles.text}>{getTimeLeft(closeDate)}</span>
        </div>
        <div className={userInfoStyles.moneyInfo}>
          <div className={userInfoStyles.blackBlock}>
            {auctionBidsInfo?.totalBids} bidders
          </div>
          <div className={userInfoStyles.blackBlock}>
            Highest bid:{' '}
            {auctionBidsInfo?.highestBid != null
              ? `$${auctionBidsInfo.highestBid / 100}/month`
              : 'N/A'}
          </div>
        </div>
        <div className={userInfoStyles.timeWrapper}>
          <div>
            Open:
            <span className={userInfoStyles.text}> {formattedCreatedAt}</span>
          </div>
          -
          <div>
            Close:{' '}
            <span className={userInfoStyles.text}>{formattedCloseDate}</span>
          </div>
        </div>
        <div>
          Seats:<span className={userInfoStyles.text}>{open_seat_count} </span>
        </div>
      </div>
      <div>
        <div className={userInfoStyles.auctionLink}>
          <div className={userInfoStyles.auctionLinkWrapper}>
            <div className={userInfoStyles.linkMobile}>
              {auctionLink.length > 47
                ? `${auctionLink.slice(0, 42)}...`
                : auctionLink}
            </div>
            <div onClick={handleCopyLink}>
              <ContentCopyIcon sx={{ cursor: 'pointer', color: 'black' }} />
            </div>
          </div>
        </div>
        <div className={styles.flexBetween}>
          <button className={userInfoStyles.btn} onClick={handleGoToAuction}>
            View Public Auction
          </button>

          <button className={userInfoStyles.btn} onClick={handleCancelAuction}>
            Cancel Auction
          </button>
        </div>
      </div>
    </div>
  );
};
